import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.6198 3.5657a2.325 2.325 0 1 1 1.7795 4.296 2.325 2.325 0 0 1-1.7795-4.296m.8898 1.323a.825.825 0 1 0 0 1.65.825.825 0 0 0 0-1.65",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.1778 6.1985a.75.75 0 0 1 1.0474-.167l1.3496.9787a.75.75 0 1 1-.8805 1.2143l-1.3496-.9786a.75.75 0 0 1-.167-1.0474m-1.5579 9.9668a2.324 2.324 0 0 1 1.7795 0 2.324 2.324 0 0 1 1.2583 1.2582 2.3255 2.3255 0 0 1-.504 2.5338 2.324 2.324 0 0 1-1.644.681 2.326 2.326 0 0 1-1.644-.681 2.3248 2.3248 0 0 1 .7542-3.792m.8898 1.323a.824.824 0 0 0-.5834.2416.825.825 0 1 0 .5834-.2416",
        clipRule: "evenodd"
    }, "1"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.7416 15.9688a.75.75 0 0 1-.1666 1.0475l-1.3496.9793a.75.75 0 0 1-.881-1.2141l1.3497-.9793a.75.75 0 0 1 1.0475.1666m7.7239-11.8991a2.325 2.325 0 1 1 3.288 3.288 2.325 2.325 0 0 1-3.288-3.288m1.644.819a.825.825 0 0 0-.825.825.8251.8251 0 1 0 .825-.825",
        clipRule: "evenodd"
    }, "2"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17.4413 6.1985a.75.75 0 0 1-.1669 1.0474l-1.3496.9786a.75.75 0 0 1-1.0474-.167.75.75 0 0 1 .1669-1.0473l1.3496-.9786a.75.75 0 0 1 1.0474.1669m-.9758 10.4708a2.3247 2.3247 0 0 1 3.2881 0 2.325 2.325 0 1 1-3.2881 0m1.644.819a.8249.8249 0 0 0-.5833 1.4083.8245.8245 0 0 0 1.1667 0 .8249.8249 0 0 0-.5834-1.4083",
        clipRule: "evenodd"
    }, "3"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.8775 15.9688a.75.75 0 0 1 1.0475-.1666l1.3496.9793a.75.75 0 0 1-.8809 1.2141l-1.3496-.9793a.75.75 0 0 1-.1666-1.0475M12.6 9.8994h-1.2c-.8284 0-1.5.6716-1.5 1.5v1.2c0 .8284.6716 1.5 1.5 1.5h1.2c.8285 0 1.5-.6716 1.5-1.5v-1.2c0-.8284-.6715-1.5-1.5-1.5m-1.2-1.5c-1.6568 0-3 1.3432-3 3v1.2c0 1.6569 1.3432 3 3 3h1.2c1.6569 0 3-1.3431 3-3v-1.2c0-1.6568-1.3431-3-3-3z",
        clipRule: "evenodd"
    }, "4"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M11.9885 12.6711a.779.779 0 0 0 .7789-.7789.779.779 0 0 0-.7789-.7789.779.779 0 0 0-.7789.7789c0 .4302.3487.7789.7789.7789"
    }, "5")
], "Omnichannel", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
